import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPulse = () => {
  return (
    <g>
      <path d="M5.956 1.548C6.154.82 7.157.82 7.387 1.49l.03.112 1.792 9.197 1.695-6.732c.163-.647 1.008-.762 1.353-.234l.055.1 1.666 3.57h1.271a.75.75 0 0 1 .744.649l.007.102a.75.75 0 0 1-.649.743l-.102.007h-1.748a.75.75 0 0 1-.628-.339l-.052-.094-.976-2.092-2 7.95c-.185.738-1.202.748-1.434.073l-.03-.113-1.823-9.346-1.612 5.907a.751.751 0 0 1-1.262.327l-.07-.083-1.593-2.191H.751a.75.75 0 0 1-.744-.648L0 8.254a.75.75 0 0 1 .649-.744l.102-.006h1.652c.206 0 .401.084.542.23l.065.079.899 1.234 2.047-7.5z" />
    </g>
  );
};

export default withIcon(IconPulse);
